
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useSettings } from "../context/SettingsProvider";
import "./StaticPage.css";

function PressPage() {
    const { settings } = useSettings();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="main-content">
            <Helmet>
                <title>Press & Media - {settings?.site_name || "Play Store"}</title>
                <meta name="description" content="Press releases, media kit, and company information" />
            </Helmet>

            <div className="static-page-container">
                <div className="page-header">
                    <h1>Press & Media</h1>
                    <p className="page-subtitle">Latest news, press releases, and media resources</p>
                </div>

                <div className="page-content">
                    <section className="content-section">
                        <h2>📰 Latest News</h2>
                        <div className="news-list">
                            <div className="news-item">
                                <span className="news-date">December 2024</span>
                                <h3>{settings?.site_name} Reaches 1 Million Downloads</h3>
                                <p>Our platform continues to grow with over 1 million app downloads and counting.</p>
                            </div>
                            <div className="news-item">
                                <span className="news-date">November 2024</span>
                                <h3>New Developer Tools Launched</h3>
                                <p>We've introduced enhanced analytics and monetization features for developers.</p>
                            </div>
                        </div>
                    </section>

                    <section className="content-section">
                        <h2>📦 Media Kit</h2>
                        <p>Download our official logos, screenshots, and brand guidelines.</p>
                        <div className="media-kit-grid">
                            <div className="media-kit-item">
                                <h4>Logos</h4>
                                <p>PNG, SVG formats</p>
                            </div>
                            <div className="media-kit-item">
                                <h4>Screenshots</h4>
                                <p>High-resolution images</p>
                            </div>
                            <div className="media-kit-item">
                                <h4>Brand Guidelines</h4>
                                <p>Usage and style guide</p>
                            </div>
                        </div>
                    </section>

                    <section className="content-section">
                        <h2>📧 Media Contact</h2>
                        <p>For press inquiries, please contact:</p>
                        <div className="contact-info">
                            <p><strong>Email:</strong> press@{settings?.site_name?.toLowerCase() || "example"}.com</p>
                            <p><strong>Phone:</strong> {settings?.support_phone || "+1 (555) 123-4567"}</p>
                        </div>
                    </section>

                    <section className="content-section">
                        <h2>📊 Company Facts</h2>
                        <ul className="facts-list">
                            <li><strong>Founded:</strong> 2024</li>
                            <li><strong>Platform:</strong> Mobile App Distribution</li>
                            <li><strong>Users:</strong> Growing community of app enthusiasts</li>
                            <li><strong>Developers:</strong> Thousands of active developers</li>
                        </ul>
                    </section>
                </div>
            </div>
        </main>
    );
}

export default PressPage;
